import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'

const ISOGRAM_MIN_LENGTH = 6

export const isogramCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isAcceptedWordEntry(entry) || entry.word.length < ISOGRAM_MIN_LENGTH) {
    return false
  }
  return new Set(entry.word.toUpperCase()).size === entry.word.length
}
